var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7323_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.60313 0.5 0 4.10313 0 8.5C0 12.8969 3.60313 16.5 8 16.5C12.3969 16.5 16 12.8969 16 8.5C16 4.10313 12.3969 0.5 8 0.5ZM1.90625 8.5C1.90625 5.14372 4.64372 2.40625 8 2.40625C9.26559 2.40625 10.4844 2.79997 11.525 3.54059L8 7.06559L3.04066 12.025C2.29997 10.9843 1.90625 9.76559 1.90625 8.5ZM8 14.5938C6.73441 14.5938 5.51559 14.2 4.475 13.4593L12.9594 4.97497C13.7 6.01559 14.0938 7.23434 14.0938 8.5C14.0938 11.8562 11.3563 14.5938 8 14.5938Z",
    fill: "#FF3636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C16 12.8969 12.3969 16.5 8 16.5V14.5938C11.3563 14.5938 14.0938 11.8562 14.0938 8.5C14.0938 7.23434 13.7 6.01559 12.9593 4.975L8 9.93434V7.06559L11.525 3.54059C10.4844 2.79997 9.26559 2.40625 8 2.40625V0.5C12.3969 0.5 16 4.10313 16 8.5Z",
    fill: "#F40000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7323_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/Disable.96b4c9091472d2dce47a441ff7f40ea4.svg";
export { ForwardRef as ReactComponent };